import { getField, updateField } from "vuex-map-fields"

export const state = () => ({
    onboardingData: [],
    currentProgress: null,
    currentLevelInfo: null,
    nextLevelInfo: null,
    nextLevelWithAtLeastOneIncompleteTask: null,
    displayedFooter: false,
    activeRequest: null,
    displayedVideoKeys: {},
    videoCompleted: false,
    showModal: false,
    showModalForced: false,
    currentLessonData: null,
    thumbnailUrl: null,
    viewLevel: null,
    pendingReward: null
})

export const getters = {
    getField
}

export const mutations = {
    updateField,
    markVideoKeyDisplayed(state, key) {
        state.displayedVideoKeys = {
            ...state.displayedVideoKeys,
            [key]: true
        }
    },
    setVideoCompleted(state, value) {
        state.videoCompleted = value;
    },
    setShowModal(state, value) {
        state.showModal = value;
    }
} 